import { FolderOpenTwoTone, HddTwoTone } from '@ant-design/icons'
import React, { useEffect, forwardRef, useMemo, useState, useImperativeHandle } from 'react';
import { Modal, Space, Spin, Tree, Tag, notification } from 'antd'
import { useSelector, useDispatch } from "react-redux";
import getTreeNodeIcon from '@common/getTreeNodeIcon'
import styles from './styles.module.less'
import confirmPrompt from '@common/confirmPrompt';
import { moveDevices } from '@app/server/ofbiz/equipmentGroup';
import { getDeviceMonitorTreeData } from '@app/actions/deviceMonitorTree_action';
// 使用了connect
// import * as deviceMonitorTreeActions from '@app/actions/deviceMonitorTree_action';
// import { bindActionCreators } from 'redux';
// import { connect } from 'react-redux';
// 直接使用dispatch 使用
// import { setDeviceMonitorTreeData } from '@app/actions/deviceMonitorTree_action';
const TreeNode = Tree.TreeNode;

// 在树中查找目标节点的父分组；找到返回父分组节点（可能为 null 表示无分组父节点），找不到返回 undefined
const findParentGroup = (nodes, targetId, parent) => {
  for (const item of (nodes || [])) {
    if (item.RecId === targetId) {
      return parent || null;
    }
    const hit = findParentGroup(item.children, targetId, item.type === 'group' ? item : parent);
    if (hit !== undefined) {
      return hit;
    }
  }
  return undefined;
};


const loopGoups = (data, type) => data && data.map((item, i) => {
  // const index = item.name.toLowerCase().indexOf(searchValue.toLowerCase());
  // const beforeStr = item.name.substr(0, index);
  // const searchStr = item.name.substr(index, searchValue.length);
  // const afterStr = item.name.substr(index + searchValue.length);
  // const title = index > -1 ? (
  //     <span style={{userSelect: 'none'}} title={item.name} 
  //     // onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}
  //     >{beforeStr}<span className="search-str">{searchStr}</span>{afterStr}{item.type == 'group' ? `(${item.children.length})` : ''}</span>
  // ) : <span style={{userSelect: 'none'}} title={item.name} 
  // // onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}
  // >{item.name}{item.type == 'group' ? `(${item.children.length})` : ''}</span>;
  // // const _icon = <img style={{marginBottom: '6px', marginRight: '5px'}} src={item.iconUrl} />;
  // console.log(data)


  const _icon = ({ expanded }) => getTreeNodeIcon(item, expanded);
  if (item.children && item.children.length && (item.type === 'group')) {
    return (
      <TreeNode icon={_icon} key={item.RecId} title={item.name}>
        {loopGoups(item.children)}
      </TreeNode>
    );
  }
  return (item.type === 'group') && (<TreeNode icon={_icon} key={item.RecId} title={item.name} />);
});

const loopAll = (data, type) => data && data.map((item, i) => {
  // const index = item.name.toLowerCase().indexOf(searchValue.toLowerCase());
  // const beforeStr = item.name.substr(0, index);
  // const searchStr = item.name.substr(index, searchValue.length);
  // const afterStr = item.name.substr(index + searchValue.length);
  // const title = index > -1 ? (
  //     <span style={{userSelect: 'none'}} title={item.name} 
  //     // onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}
  //     >{beforeStr}<span className="search-str">{searchStr}</span>{afterStr}{item.type == 'group' ? `(${item.children.length})` : ''}</span>
  // ) : <span style={{userSelect: 'none'}} title={item.name} 
  // // onMouseDown={(e)=>this.onMouseDownTreeNode(e, item)}
  // >{item.name}{item.type == 'group' ? `(${item.children.length})` : ''}</span>;
  // // const _icon = <img style={{marginBottom: '6px', marginRight: '5px'}} src={item.iconUrl} />;
  // console.log(data)


  const _icon = ({ expanded }) => getTreeNodeIcon(item, expanded);
  if (item.children && item.children.length && (item.type === 'group' || item.type === "equipment")) {
    return (
      <TreeNode icon={_icon} key={item.RecId} title={item.name} disabled={item.type === 'group'}>
        {loopAll(item.children)}
      </TreeNode>
    );
  }
  return (item.type === 'group' || item.type === "equipment") && (<TreeNode disabled={item.type === 'group'} icon={_icon} key={item.RecId} title={item.name} />);
});


const MoveEquipment = (props, ref) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadingMove, setloadingMove] = useState(false);
  const [allselectedKeys, setAllSelectedKeys] = useState([]);
  const [allcheckedNodes, setcheckedNodes] = useState([]);
  const [groupCheckedNodes, setgroupCheckedNodes] = useState([]);
  const [groupSelectedKeys, setGroupSelectedKeys] = useState([]);

  const treeStore = useSelector((state) => state.deviceMonitorTreeReducer.treeStore);
  const dispatch = useDispatch();

  const allTreeData = useMemo(() => loopAll(treeStore), [treeStore])
  const goupsTreeData = useMemo(() => loopGoups(treeStore), [treeStore])
  console.log(allTreeData);



  useImperativeHandle(
    ref,
    () => ({ showModal })
  );

  useEffect(() => {
    console.log(props)
    // setIsModalOpen(props.isModalOpen);

  }, [props])

  const showModal = (node) => {
    setIsModalOpen(true);
    // 默认勾选右键选中的设备，并选中其当前所在的分组
    if (node && node.RecId) {
      setAllSelectedKeys([node.RecId]);
      setcheckedNodes([{ key: node.RecId, title: node.name }]);
      const parent = findParentGroup(treeStore, node.RecId);
      if (parent) {
        setGroupSelectedKeys([parent.RecId]);
        setgroupCheckedNodes({ key: parent.RecId, title: parent.name });
        return;
      }
    }
    setGroupSelectedKeys([]);
    setgroupCheckedNodes([]);
  };

  const handleOk = () => {
    console.log(allselectedKeys)
    console.log(groupSelectedKeys)
    console.log(allcheckedNodes)
    console.log(groupCheckedNodes)
    // setIsModalOpen(false);
    if (allselectedKeys.length === 0) {
      Modal.warning({
        title: '提示！',
        content: '请选择需要移动的设备资源',
      });
      return
    }
    if (groupSelectedKeys.length === 0) {
      Modal.warning({
        title: '提示！',
        content: '请选择移动的目标分组',
      });
      return
    }

    confirmPrompt('提示！',
      <div><span>确定把</span>
        {
          allcheckedNodes.map(item => <Tag key={item.key} icon={<HddTwoTone twoToneColor={'#00cc00'} />} color="success">{item.title}</Tag>)
        }
        <span>移动到</span> <Tag icon={<FolderOpenTwoTone twoToneColor={'red'} />} color="warning">{groupCheckedNodes.title}</Tag>
        ？
      </div>,
      () => {
        console.log(13456466)
        sendMoveEquipments(groupSelectedKeys.toString(), allselectedKeys.toString())
      },
      () => {
        console.log('取消')

      }
    )
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    console.log("Cancelling")
  };

  const allOnCheck = (checkedKeysValue, info) => {
    console.log('onCheck', checkedKeysValue);
    console.log('info', info);
    setAllSelectedKeys(checkedKeysValue);
    setcheckedNodes(info.checkedNodes)
  };

  const groupsOnCheck = (checkedKeysValue, info) => {
    console.log('onCheck', checkedKeysValue);
    console.log('info', info);
    setGroupSelectedKeys(checkedKeysValue);
    setgroupCheckedNodes(info.node)
  };

  const sendMoveEquipments = (groupid, machineid) => {
    console.log(machineid)
    console.log(groupid)
    setloadingMove(true)
    moveDevices(groupid, machineid).then((res) => {
      console.log(res)
      setloadingMove(false)
      setIsModalOpen(false)
      notification.success({
        message: '系统提示',
        description: '移动成功',
      });

      // 直接使用dispatch
      dispatch(getDeviceMonitorTreeData(null, (result) => {
        console.log(result)
        // if (result) {
        //   Utils.showMessageDialog("提示", "IT资源树刷新成功！");
        // } else {
        //   Utils.showMessageDialog("提示", "IT资源树刷新失败！", 'error');
        // }
      }))

      // 直接使用dispatch
      // dispatch(setDeviceMonitorTreeData(data))
    }).catch((error) => {
      console.log(error)
      setloadingMove(false)
    })
  }

  return (
    <div>
      <Modal title="移动资源" open={isModalOpen} onOk={handleOk} onCancel={handleCancel} width={800}>
        <Spin spinning={loadingMove} tip="正在移动...">
          <div className={styles.MoveEquipmentWrip}>
            {props.resourcePanelShow ? 'true' : 'false'}
            <Space size={100}>
              <div
                className={styles.TreeDataContainer}
              >
                <Tree
                  showIcon
                  checkable
                  defaultExpandAll={true}
                  onCheck={allOnCheck}
                  checkedKeys={allselectedKeys}
                  selectedKeys={allselectedKeys}
                >
                  {allTreeData}
                </Tree>
              </div>
              <div
                className={styles.TreeDataContainer}
              >
                <Tree
                  showIcon
                  defaultExpandAll={true}
                  onSelect={groupsOnCheck}
                  selectedKeys={groupSelectedKeys}
                >
                  {goupsTreeData}
                </Tree>
              </div>
            </Space>
          </div>
        </Spin>
      </Modal>
    </div>
  );
};


// const mapStateToProps = (state) => {
//   let {  resourcePanelShow } = state.deviceMonitorTreeReducer;
//   return {
//     resourcePanelShow
//   }
// }
// const mapDispatchToProps = (dispatch) => {
//   return {
//     deviceMonitorTreeActions: bindActionCreators(deviceMonitorTreeActions, dispatch),
//   }
// }
// export default connect(
//   mapStateToProps,
//   mapDispatchToProps,
//   // 需要调用组件的方法 ， 并且使用了connect 则
//   null,
//   { forwardRef: true }
// )(forwardRef(MoveEquipment))



export default (forwardRef(MoveEquipment))